import {HttpClient, HttpErrorResponse, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {
  CanalVendaVM,
  LimpezaFood99VM,
  ComparacaoAtualIfoodVM, ResolucaoAdicionalIfoodVM,
  CategoriaExternaCanalVendaVM,
  ConfiguracaoProdutoCanalVenda,
  CriacaoLoteCanalVendaVM,
  DestinosCanalVendaVM,
  FiltrosCatalogoCanalVenda,
  HistoricoProdutoCanalVendaVM,
  PaginaCatalogoCanalVendaVM,
  PendenciasRecursosCanalVendaVM,
  PendenciaComparacaoIfoodVM,
  PrecosAdicionalCanaisVM,
  PreviaCanalVendaVM,
  ProdutoCatalogoCanalVendaVM,
  PublicacaoCanalVendaVM,
  ResumoPublicacaoCanalVendaVM,
  ResultadoMassaCanalVendaVM,
  ResultadoVinculacaoProdutoIfoodVM,
  PreviaVinculacaoProdutoCanalVendaVM,
  CorrespondenciasVinculacaoProdutoCanalVendaVM,
  PreviaMesclagemVinculacaoVM
} from './canais-venda.models';

interface RespostaApi<T> {
  sucesso: boolean;
  data?: T;
  erro?: string;
  codigo?: string;
  pendenciasAdicionais?: PendenciaComparacaoIfoodVM[];
}

export class ErroHttpCanalVenda extends Error {
  constructor(
    readonly status: number,
    readonly codigo: string | null,
    mensagem: string,
    readonly pendenciasAdicionais: PendenciaComparacaoIfoodVM[] = []
  ) {
    super(mensagem);
    console.error(this)
  }
}

@Injectable()
export class CanaisVendaFacade {
  private readonly baseUrl = '/canais-venda';

  constructor(private http: HttpClient) {}

  previaLimpezaFood99(canalId: number): Promise<LimpezaFood99VM> {
    return this.execute(this.http.post<RespostaApi<LimpezaFood99VM>>(`${this.baseUrl}/canais/${canalId}/limpeza-food99/previa`, {}));
  }
  confirmeLimpezaFood99(canalId: number, id: number): Promise<LimpezaFood99VM> {
    return this.execute(this.http.post<RespostaApi<LimpezaFood99VM>>(`${this.baseUrl}/canais/${canalId}/limpeza-food99/confirmar`, {id, confirmacao: 'ZERAR'}));
  }
  consulteLimpezaFood99(canalId: number): Promise<LimpezaFood99VM> {
    return this.execute(this.http.post<RespostaApi<LimpezaFood99VM>>(`${this.baseUrl}/canais/${canalId}/limpeza-food99/consultar`, {}));
  }

  compareProdutoIfood(canalId: number, produtoId: number): Promise<ComparacaoAtualIfoodVM> {
    return this.execute(this.http.get<RespostaApi<ComparacaoAtualIfoodVM>>(
      `${this.baseUrl}/canais/${canalId}/produtos/${produtoId}/comparacao-ifood`));
  }

  prepareProdutoAusenteIfood(canalId: number, produtoId: number, versao: string): Promise<any> {
    return this.execute(this.http.post<RespostaApi<any>>(
      `${this.baseUrl}/canais/${canalId}/produtos/${produtoId}/comparacao-ifood/recriar`, {versao}));
  }

  adicioneComparacaoIfoodRevisao(canalId: number, produtoId: number, versao: string, campos: string[], resolucoesAdicionais: ResolucaoAdicionalIfoodVM[] = []): Promise<any> {
    return this.execute(this.http.post<RespostaApi<any>>(
      `${this.baseUrl}/canais/${canalId}/produtos/${produtoId}/comparacao-ifood/revisao`, {versao, campos, resolucoesAdicionais}));
  }

  listeDestinos(): Promise<DestinosCanalVendaVM> {
    return this.execute(this.http.get<RespostaApi<DestinosCanalVendaVM>>(
      `${this.baseUrl}/destinos`
    ));
  }

  listeMenusFood99(integracaoId: number): Promise<Array<{id: string; nome: string}>> {
    return this.execute(this.http.get<RespostaApi<Array<{id: string; nome: string}>>>(
      `${this.baseUrl}/destinos/FOOD99/${integracaoId}/catalogos`));
  }

  canceleTentativaNaoEnviada(canalId: number, publicacaoId: number, produtoId?: number): Promise<{publicacaoId: number}> {
    return this.execute(this.http.post<RespostaApi<{publicacaoId: number}>>(
      `${this.baseUrl}/canais/${canalId}/publicacoes/${publicacaoId}/cancelar-tentativa`, produtoId ? {produtoId} : {}));
  }

  reconcilieMenuFood99(canalId: number, publicacaoId: number): Promise<{publicacaoId: number}> {
    return this.execute(this.http.post<RespostaApi<{publicacaoId: number}>>(
      `${this.baseUrl}/canais/${canalId}/publicacoes/${publicacaoId}/reconciliar-menu`, {}));
  }

  listeCanais(): Promise<CanalVendaVM[]> {
    return this.execute(this.http.get<RespostaApi<CanalVendaVM[]>>(`${this.baseUrl}/canais`));
  }

  listeCanaisProduto(produtoId: number): Promise<Array<{canal: CanalVendaVM; produto: ProdutoCatalogoCanalVendaVM}>> {
    return this.execute(this.http.get<RespostaApi<Array<{canal: CanalVendaVM; produto: ProdutoCatalogoCanalVendaVM}>>>(
      `${this.baseUrl}/produtos/${produtoId}/canais`
    ));
  }

  listeCanaisAdicional(adicionalId: number): Promise<PrecosAdicionalCanaisVM> {
    return this.execute(this.http.get<RespostaApi<PrecosAdicionalCanaisVM>>(
      `${this.baseUrl}/adicionais/${adicionalId}/canais`
    ));
  }

  configurePrecoOpcao(
    canalVendaId: number,
    opcaoId: number,
    preco: {modo: 'CONFIGURACAO_CANAL'} |
      {modo: 'ESPECIFICO'; valor: number; desconto: number}
  ): Promise<{salvou: boolean; publicou: boolean}> {
    return this.execute(this.http.put<RespostaApi<any>>(
      `${this.baseUrl}/canais/${canalVendaId}/opcoes/${opcaoId}/preco`, preco
    ));
  }

  crieCanal(dados: {
    nome: string;
    plataforma?: 'IFOOD' | 'FOOD99';
    integracaoId: number;
    merchantId: string;
    catalogoExternoId: string;
    catalogoId?: number;
    percentualPrecoPadrao?: number | null;
  }): Promise<CanalVendaVM> {
    return this.execute(this.http.post<RespostaApi<CanalVendaVM>>(
      `${this.baseUrl}/canais`, dados
    ));
  }

  configurePrecoCanal(
    canalVendaId: number,
    percentualPrecoPadrao: number | null
  ): Promise<{canal: CanalVendaVM; produtosImpactados: number}> {
    return this.execute(this.http.put<RespostaApi<any>>(
      `${this.baseUrl}/canais/${canalVendaId}/configuracao-preco`,
      {percentualPrecoPadrao}
    ));
  }

  ativeCanal(canalVendaId: number): Promise<CanalVendaVM> {
    return this.execute(this.http.post<RespostaApi<CanalVendaVM>>(
      `${this.baseUrl}/canais/${canalVendaId}/ativar`, {}
    ));
  }

  vinculeExistentes(
    canalVendaId: number,
    dados: {produtoIds?: number[]; somenteSemVinculo?: boolean} = {}
  ): Promise<ResultadoVinculacaoProdutoIfoodVM> {
    return this.execute(this.http.post<RespostaApi<ResultadoVinculacaoProdutoIfoodVM>>(
      `${this.baseUrl}/canais/${canalVendaId}/vincular-existentes`, dados));
  }

  previsualizeVinculacao(canalVendaId: number): Promise<PreviaVinculacaoProdutoCanalVendaVM> {
    return this.execute(this.http.get<RespostaApi<PreviaVinculacaoProdutoCanalVendaVM>>(
      `${this.baseUrl}/canais/${canalVendaId}/vinculacao-preview`));
  }

  vinculeProdutoComCorrespondencias(
    canalVendaId: number, produtoId: number, itemId: string,
    correspondencias: CorrespondenciasVinculacaoProdutoCanalVendaVM
  ): Promise<ResultadoVinculacaoProdutoIfoodVM> {
    return this.execute(this.http.post<RespostaApi<ResultadoVinculacaoProdutoIfoodVM>>(
      `${this.baseUrl}/canais/${canalVendaId}/vinculacoes/produto`,
      {produtoId, itemId, correspondencias}
    ));
  }

  previsualizeMesclagemVinculacao(
    canalVendaId: number, produtoId: number, itemId: string
  ): Promise<PreviaMesclagemVinculacaoVM> {
    return this.execute(this.http.get<RespostaApi<PreviaMesclagemVinculacaoVM>>(
      `${this.baseUrl}/canais/${canalVendaId}/vinculacoes/produto/previa`,
      {params: {produtoId: String(produtoId), itemId}}
    ));
  }

  vinculeProdutoSelecionado(canalVendaId: number, produtoId: number, itemId: string,
                            codigoPdvDecisao: 'LOCAL' | 'IFOOD' | null = null): Promise<ResultadoVinculacaoProdutoIfoodVM> {
    return this.execute(this.http.post<RespostaApi<ResultadoVinculacaoProdutoIfoodVM>>(
      `${this.baseUrl}/canais/${canalVendaId}/vincular-produto-selecionado`, {produtoId, itemId, codigoPdvDecisao}));
  }

  desativeCanal(canalVendaId: number): Promise<CanalVendaVM> {
    return this.execute(this.http.post<RespostaApi<CanalVendaVM>>(
      `${this.baseUrl}/canais/${canalVendaId}/desativar`, {}
    ));
  }

  removaCanal(canalVendaId: number): Promise<{removido: boolean}> {
    return this.execute(this.http.post<RespostaApi<{removido: boolean}>>(
      `${this.baseUrl}/canais/${canalVendaId}/remover`, {}
    ));
  }

  listeCatalogo(
    canalVendaId: number,
    filtros: FiltrosCatalogoCanalVenda
  ): Promise<PaginaCatalogoCanalVendaVM> {
    return this.execute(this.http.get<RespostaApi<PaginaCatalogoCanalVendaVM>>(
      `${this.baseUrl}/canais/${canalVendaId}/catalogo`,
      {params: this.parametros(filtros)}
    ));
  }

  listePendenciasRecursos(canalVendaId: number): Promise<PendenciasRecursosCanalVendaVM> {
    return this.execute(this.http.get<RespostaApi<PendenciasRecursosCanalVendaVM>>(
      `${this.baseUrl}/canais/${canalVendaId}/pendencias-recursos`
    ));
  }

  configureProduto(
    canalVendaId: number,
    produtoId: number,
    configuracao: ConfiguracaoProdutoCanalVenda
  ): Promise<any> {
    return this.execute(this.http.put<RespostaApi<any>>(
      `${this.baseUrl}/canais/${canalVendaId}/produtos/${produtoId}`,
      configuracao
    ));
  }

  apliqueMassa(canalVendaId: number, dados: {
    produtoIds: number[];
    operacao: string;
    valor?: number;
    desconto?: number;
    percentual?: number;
  }): Promise<ResultadoMassaCanalVendaVM> {
    return this.execute(this.http.post<RespostaApi<ResultadoMassaCanalVendaVM>>(
      `${this.baseUrl}/canais/${canalVendaId}/produtos/massa`, dados
    ));
  }

  gerePrevia(canalVendaId: number, dados: {
    produtoIds?: number[];
    recursoIds?: number[];
    todosPendentes?: boolean;
    incluirSnapshot?: boolean;
  }): Promise<PreviaCanalVendaVM> {
    return this.execute(this.http.post<RespostaApi<PreviaCanalVendaVM>>(
      `${this.baseUrl}/canais/${canalVendaId}/previa`, dados
    ));
  }

  confirmePrecosPrevia(canalVendaId: number, dados: {
    produtoIds: number[];
    recursoIds: number[];
    confirmacaoPrecosToken: string;
    precos: Array<{tipo: 'PRODUTO' | 'OPCAO_ADICIONAL'; alvoId: number; valor: number}>;
  }): Promise<{previa: PreviaCanalVendaVM; confirmado: boolean}> {
    return this.execute(this.http.post<RespostaApi<{previa: PreviaCanalVendaVM; confirmado: boolean}>>(
      `${this.baseUrl}/canais/${canalVendaId}/previa/precos`, dados
    ));
  }

  cancelePendenciasRecursos(canalVendaId: number, dados: {
    recursos: Array<{recursoId: number; versao: number}>;
  }): Promise<{adicionaisCancelados: number}> {
    return this.execute(this.http.post<RespostaApi<{adicionaisCancelados: number}>>(
      `${this.baseUrl}/canais/${canalVendaId}/pendencias-recursos/cancelar`, dados
    ));
  }

  listeCategoriasExternas(canalVendaId: number): Promise<CategoriaExternaCanalVendaVM[]> {
    return this.execute(this.http.get<RespostaApi<CategoriaExternaCanalVendaVM[]>>(
      `${this.baseUrl}/canais/${canalVendaId}/categorias-externas`
    ));
  }

  resolvaCategoria(
    canalVendaId: number,
    categoriaLocalId: number,
    dados: {modo: 'CRIAR' | 'EXISTENTE'; categoriaExternaId?: string}
  ): Promise<{categoriaLocalId: number; categoriaExternaId: string}> {
    return this.execute(this.http.put<RespostaApi<any>>(
      `${this.baseUrl}/canais/${canalVendaId}/categorias/${categoriaLocalId}`, dados
    ));
  }

  crieLote(
    canalVendaId: number,
    produtoIds: number[],
    confirmacaoPrecosToken: string | null = null,
    recursoIds: number[] = []
  ): Promise<CriacaoLoteCanalVendaVM> {
    return this.execute(this.http.post<RespostaApi<CriacaoLoteCanalVendaVM>>(
      `${this.baseUrl}/canais/${canalVendaId}/publicacoes`,
      {produtoIds, recursoIds, confirmacaoPrecosToken}
    ));
  }

  acompanheLote(canalVendaId: number, publicacaoId: number): Promise<PublicacaoCanalVendaVM> {
    return this.execute(this.http.get<RespostaApi<PublicacaoCanalVendaVM>>(
      `${this.baseUrl}/canais/${canalVendaId}/publicacoes/${publicacaoId}`
    ));
  }

  listePublicacoes(canalVendaId: number): Promise<ResumoPublicacaoCanalVendaVM[]> {
    return this.execute(this.http.get<RespostaApi<ResumoPublicacaoCanalVendaVM[]>>(
      `${this.baseUrl}/canais/${canalVendaId}/publicacoes`
    ));
  }

  listeHistorico(
    canalVendaId: number,
    produtoId: number,
    limite = 25
  ): Promise<HistoricoProdutoCanalVendaVM> {
    return this.execute(this.http.get<RespostaApi<HistoricoProdutoCanalVendaVM>>(
      `${this.baseUrl}/canais/${canalVendaId}/produtos/${produtoId}/historico`,
      {params: new HttpParams().set('limite', String(limite))}
    ));
  }

  reenvieFalha(
    canalVendaId: number,
    publicacaoId: number,
    itemPublicacaoId: number
  ): Promise<{publicacaoId: number; quantidadeItens: number}> {
    return this.execute(this.http.post<RespostaApi<any>>(
      `${this.baseUrl}/canais/${canalVendaId}/publicacoes/${publicacaoId}` +
      `/itens/${itemPublicacaoId}/reenvio`, {}
    ));
  }

  private execute<T>(requisicao: {toPromise(): Promise<RespostaApi<T>>}): Promise<T> {
    return requisicao.toPromise()
      .then(resposta => {
        if(resposta?.sucesso) return resposta.data as T;
        throw new ErroHttpCanalVenda(400, resposta?.codigo || null,
          resposta?.erro || 'Não foi possível concluir a operação.', resposta?.pendenciasAdicionais);
      })
      .catch(erro => {
        if(erro instanceof ErroHttpCanalVenda) throw erro;
        const http = erro as HttpErrorResponse;
        const corpo: any = http?.error || {};
        throw new ErroHttpCanalVenda(
          Number(http?.status || 0),
          corpo?.codigo || null,
          corpo?.erro || http?.message || 'Falha de comunicação com o servidor.',
          corpo?.pendenciasAdicionais
        );
      });
  }

  private parametros(filtros: FiltrosCatalogoCanalVenda): HttpParams {
    let params = new HttpParams();
    Object.keys(filtros || {}).forEach(chave => {
      const valor = (filtros as any)[chave];
      if(valor !== null && valor !== undefined && valor !== '')
        params = params.set(chave, String(valor));
    });
    return params;
  }
}
